import type { HomePageContent } from '../types/HomePageContent';

export function createHomePageContentPlaceholder(): HomePageContent {
    return {
        HeroSection: {
            pageTitle: { kind: 'plainMultilineText', key: '', content: '' },
            pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
            pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
            learnMoreLink: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
        },
        Applications: {
            title: { kind: 'plainMultilineText', key: '', content: '' },
            mainText: { kind: 'richText', key: '', content: '', sanitizedContent: '' },
            segments: {
                kind: 'productApplicationSegmentCardCollection',
                key: '',
                entries: [],
            },
        },
        Sustainability: {
            title: { kind: 'plainText', key: '', content: '' },
            subtitle: { kind: 'plainMultilineText', key: '', content: '' },
            titleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
            mainText: { kind: 'richText', key: '', content: '', sanitizedContent: '' },
            detailsLink: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
        },
        InfographicSection: {
            title: { kind: 'plainText', key: '', content: '' },
            image: { kind: 'image', key: '', imageUrl: '' },
            learnMoreLink: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
        },
        InfoBanner: {
            infoBanners: {
                kind: 'infoBannerCollection',
                key: '',
                entriesPrefix: '',
                entries: [],
            },
        },
    };
}
